<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary" to="/dashboard/league">لیگ جدید</router-link>
            <div class="table-responsive mt-2">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>زمان شروع</th>
                    <th>زمان پایان</th>
                    <th>ورودی</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="league in leagueItems" :key="league._id">
                    <td>{{ league.leagueTitle }}</td>
                    <td>{{ new Date(league.startDate).toLocaleString('fa-IR') }}</td>
                    <td>{{ new Date(league.endDate).toLocaleString('fa-IR') }}</td>
                    <td>{{ league.ticketCount }}</td>
                    <td>{{ status(league) }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/league', query: { id: league._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import leagueService from '../../../../services/league';
export default {
  name: 'league',
  data() {
    return {
      leagueItems: [],
    };
  },
  created() {
    this.getLeagues({});
  },
  methods: {
    async getLeagues(conditions) {
      try {
        const leagueItems = await leagueService.getLeagues(conditions);
        this.leagueItems = leagueItems;
        console.log(leagueItems);
      } catch (err) {
        console.log(err);
      }
    },

    status(league) {
      const startDate = new Date(league.startDate);
      const endDate = new Date(league.endDate);
      const now = new Date();
      if (endDate < now) return 'برگذار شده';
      if (startDate < now && endDate > now && league.isAvailable == true) return 'در حال برگذازی';
      if (startDate > now && league.isAvailable) return 'برگذار نشده - فعال';
      return 'برگذار نشده - غیر فعال';
    },
  },
};
</script>
